<div class="sec3">
    <h5>
        {{heading}}
    </h5>
    <span>
    <div *ngFor="let title of titlesList[0]; let i = index;">
        <a href="{{titlesList[1][i]}}" target="_blank">{{title}}</a>
    </div>
    </span>
</div>